import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { KmShellI } from '../../shared/file-import/models/km-shell.interface';
import { BackendResponse } from 'src/app/interfaces/response.interface';
import { catchError, map } from 'rxjs';
import { handleError } from 'src/app/tools/tools';

@Injectable({ providedIn: 'root' })
export class KmShellService {
  constructor(private readonly http: HttpClient) {}
  private readonly url = environment.url + 'km-shell/';

  insert(data: KmShellI[]) {
    return this.http.post<BackendResponse>(this.url, data).pipe(
      catchError((e) => handleError(e)),
      map((data) => data.ok)
    );
  }

  getAllFilter(params?: HttpParams) {
    return this.http
      .get<
        BackendResponse<{
          entities: KmShellI[];
          count: number;
        }>
      >(this.url, { params })
      .pipe(
        catchError((e) => handleError(e)),
        map((data) => data.result)
      );
  }

  getOne(id: number) {
    const direction = this.url + id;
    return this.http.get<BackendResponse<KmShellI>>(direction).pipe(
      catchError((e) => handleError(e)),
      map((data) => data.result)
    );
  }
}
